// extracted by mini-css-extract-plugin
module.exports = {"navBar":"navBarRepartidor_navBar__4_Bm5","bienvenido":"navBarRepartidor_bienvenido__2YAff","menu_button":"navBarRepartidor_menu_button__3boYQ"};